module.exports = __webpack_public_path__ + "assets/b0e9ad9dd5ef96e083c6e58679638798.png";